import { render, staticRenderFns } from "./styleExhibition.vue?vue&type=template&id=22ecefb8&scoped=true"
import script from "./styleExhibition.vue?vue&type=script&lang=js"
export * from "./styleExhibition.vue?vue&type=script&lang=js"
import style0 from "./styleExhibition.vue?vue&type=style&index=0&id=22ecefb8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ecefb8",
  null
  
)

export default component.exports